import React from "react";
import "./StoryReel.css";
import Story from "./Story";

function StoryReel() {
  return (
    <div className="storyReel">
      <Story
        image="https://eom.de/wp-content/uploads/2020/12/fragen-instagram-stories.jpg"
        profileSrc="https://www.w3schools.com/howto/img_avatar.png"
        title="Peter"
      />
      <Story
        image="https://onlinemarketing.de/wp-content/uploads/2020/01/screenshot_20200124_095531_com.instagram.android-1.jpg"
        profileSrc="https://www.w3schools.com/howto/img_avatar2.png"
        title="Lisa"
      />
      <Story
        image="https://static-cse.canva.com/blob/186593/White-Ask-Me-Personal-Instagram-Story.png"
        profileSrc="https://www.w3schools.com/w3images/avatar2.png"
        title="Rafael"
      />
      <Story
        image="https://i.pinimg.com/originals/cd/38/45/cd38456b369502c5da7cfc099af73cd8.jpg"
        profileSrc="https://www.w3schools.com/w3images/avatar6.png"
        title="Hugo"
      />
      <Story
        image="https://carina-hartmann.de/wp-content/uploads/2019/09/Instagram-Story-mit-GIF-625x1030.jpg"
        profileSrc="https://www.w3schools.com/w3images/avatar5.png"
        title="Malte"
      />
    </div>
  );
}

export default StoryReel;
